<template>
  <div ref="root" class="popup">
    <div class="popup__box">

      <div class="popup__close" @click.prevent="tapClose">
      </div>
      <div class="popup__inner-box">
        <div class="iscroll-wrapper">
          <div class="iscroll__scroller">
            <slot />
          </div>
        </div>
      </div>
    </div>
    <div class="nonScroll"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, onMounted, onUpdated } from 'vue'
import IScroll from 'iscroll'


interface State {
  iScrollObj: null | IScroll
}

export default defineComponent({
  components: {
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    tapClose: {
      type: Function,
      required: true,
    },
  },
  setup() {
    const root = ref(null)
    const state = reactive<State>({
      iScrollObj: null,
    })

    onMounted(() => {
      // state.iScrollObj = new IScroll(root.value.querySelector('.iscroll-wrapper'), {
      //   disableTouch: true,
      //   disablePointer: false,
      //   useTransition: false,
      //   scrollbars: 'custom',
      //   fadeScrollbars: true,
      // })
    })

    onUpdated(() => {
      setTimeout(() => {
        if (state.iScrollObj) {
          state.iScrollObj.refresh()
        }
      }, 300)
    })

    return { root, state }
  },
})
</script>

<style lang="scss" scoped>
@import '~@/assets/css/colors';

.popup {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100000;
  overscroll-behavior: contain;
    overflow-y: scroll;

  &__ {
    &box {
      max-width: 1300px;
      padding: 22px 30px;
      position: relative;
      width: 80%;
      height: 80%;
      border-radius: 5px;
      background: #fff;
      box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.4);
    }

    &inner-box {
      margin-top: 20px;
      width: 100%;
      height: calc(100% - 20px);
      overflow: hidden;
      word-break: break-all;
    }

    &title {
      position: relative;

      &::before {
        content: '';
        position: absolute;
        width: 5px;
        height: 100%;
        background: $main;
      }
    }

    &close {
      // position: absolute;
      // top: 18px;
      // right: 24px;
      // width: 50px;
      // height: 24px;

      position: absolute;
        top: -13px;
        right: -13px;
        width: 50px;
        height: 24px;
        display: block;
        width: 35px;
        height: 35px;
        border: 2px solid #ada554;
        border-radius: 50%;
        background: #fff;

        &::before {
        content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          width: 3px;
          /* 棒の幅（太さ） */
          height: 22px;
          /* 棒の高さ */
          background: #ada554;
          transform: translate(-50%, -50%) rotate(45deg);
        }

                &::after {
        content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          width: 3px;
          /* 棒の幅（太さ） */
          height: 22px;
          /* 棒の高さ */
          background: #ada554;
          transform: translate(-50%, -50%) rotate(-45deg);
        }
    }

    &close-text {
      text-align: center;
      font-weight: bold;
      line-height: 24px;
      color: $main;
    }
  }
}

.iscroll-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  overflow-y: scroll;
}
.iscroll__scroller {
  height: auto;
}

.nonScroll {
  height: calc(100vh + 1px);
  width: 1px;
  background-color: transparent;
}


@media screen and (max-width: 450px) {

.iscroll-wrapper {
  padding: 0 15px;
}

}
</style>
